import { DOWN_TIME_HOURS } from 'shared/constants';
import { Commodity, CommoditySummarySqlView, CommodityUserMapping, ProductsSummaryMetrics } from 'shared/types';
import { cstFormatter, formatDate } from './formats';

type CommodityToUserMappingProps = Pick<
  CommodityUserMapping,
  'createdBy' | 'createdDate' | 'userMappingId' | 'createdByEmail'
>;
export function commodityToUserMapping({
  createdBy,
  createdDate,
  userMappingId,
  createdByEmail,
}: CommodityToUserMappingProps) {
  return (commodity: Commodity): CommodityUserMapping => {
    return {
      id: `${userMappingId}${commodity.id}`,
      commodityId: commodity.id,
      createdBy,
      userMappingId,
      createdDate,
      createdByEmail,
    };
  };
}

function isDaylightSavingsTime(date: Date) {
  const jan = new Date(date.getFullYear(), 0, 1);
  const jul = new Date(date.getFullYear(), 6, 1);
  const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

  return date.getTimezoneOffset() < stdTimezoneOffset;
}

export const getNewCSTDate = (date?: Date) => {
  const dateNowCST = cstFormatter.format(date ?? new Date());
  return new Date(dateNowCST);
};

export const calculateSubmitTime = () => {
  const submitTime = new Date();
  if (isDaylightSavingsTime(submitTime)) {
    submitTime.setUTCHours(15);
  } else {
    submitTime.setUTCHours(16);
  }
  submitTime.setUTCMinutes(0);
  submitTime.setUTCSeconds(0);
  submitTime.setUTCMilliseconds(0);

  const currentTime = new Date();
  if (currentTime.getUTCHours() >= submitTime.getUTCHours()) {
    submitTime.setDate(submitTime.getDate() + 1);
  }

  return getNewCSTDate(submitTime);
};

export const commoditySummaryToProductMetrics = (summary: CommoditySummarySqlView): ProductsSummaryMetrics => {
  return {
    ...summary,
    submitByTime: calculateSubmitTime(),
  };
};

export const getNewDateFromHours = (hours: string) => {
  const dateWeAllLoseAnHourOfDaytime = new Date(2023, 10, 5, 2, 0, 0, 0);
  const isFinalTimeChangeComplete = new Date() >= dateWeAllLoseAnHourOfDaytime;
  return getNewCSTDate(
    new Date(`${formatDate(getNewCSTDate())} ${hours} ${isFinalTimeChangeComplete ? 'cst' : 'cdt'}`)
  );
};

export const checkDownTime = () => {
  const now = getNewCSTDate();
  const downTimeHours = DOWN_TIME_HOURS.filter(({ startHour, endHour }) => {
    const start = getNewDateFromHours(startHour);
    const end = getNewDateFromHours(endHour);

    return start <= now && now < end;
  });

  return downTimeHours.length > 0 && downTimeHours[0].endHour;
};

export function handleBlob(blob: Blob, fileName: string) {
  const blobUrl = URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', fileName);
  link.click();
}
